import { ReactNode } from 'react';

import { Add, Close, Delete, Done } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';

import { formRowsStyles } from './FormRows.styles';

export interface ItemRowProps {
  prefix: `${string}.${number}.items.${number}`;
  prefixForMainProperties?: `${string}.${number}`;
  onClick?: () => void;
  isLast: boolean;
  isFull?: boolean;
}

interface ItemRowInternalProps extends Omit<ItemRowProps, 'prefix'> {
  children: ReactNode;
  error?: string;
  success?: boolean;
}

export const ItemRow = ({
  children,
  onClick,
  isLast,
  isFull,
  error,
  success,
}: ItemRowInternalProps) => {
  const generateIcon = () => {
    if (!onClick) {
      return <></>;
    }
    if (isLast) {
      // No status indicator
      return (
        <IconButton
          data-testid="add-item-row"
          onClick={onClick}
          sx={formRowsStyles.button}
          disabled={isFull}
          size="large"
        >
          <Add />
        </IconButton>
      );
    }
    if (success) {
      // Checkmark button, no actions
      return (
        <Done
          sx={{
            ...formRowsStyles.button,
            ...formRowsStyles.statusIcon,
            ...formRowsStyles.successIcon,
          }}
        />
      );
    }
    // Default "delete" action
    return (
      <IconButton
        data-testid="delete-item-row"
        onClick={onClick}
        sx={formRowsStyles.button}
        size="large"
      >
        <Delete />
      </IconButton>
    );
  };

  return (
    <Box sx={formRowsStyles.container}>
      {children}
      {error && (
        <Box display="flex" gap={1} alignItems="center">
          <Close color="error" sx={formRowsStyles.statusIcon} />
          <Typography variant="subtitle2" color="error">
            {error}
          </Typography>
        </Box>
      )}
      {generateIcon()}
    </Box>
  );
};
